export default __webpack_public_path__ + "static/media/first_order_with_zero.15e7156b.svg";